import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { SiteFooter } from './components/SiteFooter';
import { SiteHeader } from './components/SiteHeader';
import { About } from './pages/About';
import { Advisory } from './pages/Advisory';
import { BooksAndMedia } from './pages/BooksAndMedia';
import { Contact } from './pages/Contact';
import { Education } from './pages/Education';
import { ExecutiveProfile } from './pages/ExecutiveProfile';
import { Experience } from './pages/Experience';
import { Home } from './pages/Home';
import { Honors } from './pages/Honors';
import { Skills } from './pages/Skills';
interface AppProps {
  experienceLayout?: 'tabs' | 'accordion';
}
export function App({
  experienceLayout = 'tabs'
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="28t4kmbsl46ry">
      <ScrollToTop data-id="element-1" data-mp="28sl5f2ubjwhm" />
      <div className="min-h-full w-full bg-offwhite font-sans" data-id="element-2" data-mp="28s30zixi6bym">
        <SiteHeader data-id="element-3" data-mp="23utas12ahw9q" />
        <main data-id="element-4" data-mp="23t8h0dnsuhcx">
          <Routes data-id="element-5" data-mp="3ijxnsm94vshs">
            <Route path="/" element={<Home data-id="element-7" data-mp="3ij652c0mxp8x" />} data-id="element-6" data-mp="3ikhaeg9qb525" />
            <Route path="/about" element={<About data-id="element-9" data-mp="3mlj82snzz920" />} data-id="element-8" data-mp="3ijpcuzwkmx98" />
            <Route path="/executive-profile" element={<ExecutiveProfile data-id="element-11" data-mp="3mjq2lgp4euvl" />} data-id="element-10" data-mp="3mkrdnl64zhdb" />
            <Route path="/experience" element={<Experience layout={experienceLayout} data-id="element-13" data-mp="3rdaselgk8ijp" />} data-id="element-12" data-mp="3rcj6618urx63" />
            <Route path="/skills" element={<Skills data-id="element-15" data-mp="67yvnd9206b" />} data-id="element-14" data-mp="5yjetptzbev" />
            <Route path="/education" element={<Education data-id="element-17" data-mp="7ssnarqpf34" />} data-id="element-16" data-mp="5gez9t0lqvv" />
            <Route path="/advisory" element={<Advisory data-id="element-19" data-mp="2zmemy5wtxg6g" />} data-id="element-18" data-mp="2zlldgx6hkckm" />
            <Route path="/books-and-media" element={<BooksAndMedia data-id="element-21" data-mp="33m5c656pjo8v" />} data-id="element-20" data-mp="2zn6cayzu2hoa" />
            <Route path="/honors" element={<Honors data-id="element-23" data-mp="33oi3h8ycvayl" />} data-id="element-22" data-mp="33n6zp94wu37h" />
            <Route path="/contact" element={<Contact data-id="element-25" data-mp="38l04bxqkep5n" />} data-id="element-24" data-mp="38m1jadapbvsn" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-27" data-mp="3dkuu1xylt8p4" />} data-id="element-26" data-mp="38kgocmkh6au9" />
          </Routes>
        </main>
        <SiteFooter data-id="element-28" data-mp="3dm5vvs8ho6dl" />
      </div>
    </BrowserRouter>;
}